import {
  GroupMeetingCallIcon,
  InboxOpenIcon,
  UserCheckValidateIcon,
} from "icons";
import React from "react";

import { ClientQuarterPipeline } from "@/hooks/api/generated";
import { QuarterCardEmpty } from "@/src/app/[locale]/(private)/profile/[tab]/components/hiring-pipeline/QuarterCardEmpty";

export function QuarterCard({
  quarter,
}: {
  quarter: ClientQuarterPipeline;
}): JSX.Element {
  if (quarter.applicants === 0) {
    return <QuarterCardEmpty quarter={quarter} />;
  }

  return (
    <div className="w-full h-full p-4 bg-white rounded-[10px] outline outline-1 outline-[#E5E7EB] outline-offset-[-1px] inline-flex flex-col justify-start items-start gap-3">
      <div className="w-full h-[33px] pb-[1px] border-b border-[#E5E7EB] flex flex-col justify-start items-start">
        <div className="text-[#0A0A0A] text-base font-semibold">
          {quarter.quarter}
        </div>
      </div>
      <div className="w-full flex flex-col justify-start items-start gap-2">
        <div className="w-full inline-flex justify-start items-center gap-2">
          <div className="w-[18px] h-[18px] relative overflow-hidden">
            <InboxOpenIcon />
          </div>
          <div className="w-[65.1px] inline-flex flex-col justify-start items-start">
            <div className="text-[#21597A] text-lg font-semibold">
              {quarter.applicants > 0 ? quarter.applicants : "—"}
            </div>
            <div className="text-black text-xs font-normal leading-4">
              Applications
            </div>
          </div>
        </div>
        <div className="w-full inline-flex justify-start items-center gap-2">
          <div className="w-[18px] h-[18px] relative overflow-hidden">
            <GroupMeetingCallIcon />
          </div>
          <div className="w-[65.1px] inline-flex flex-col justify-start items-start">
            <div className="text-[#BF4900] text-lg font-semibold">
              {quarter.interviews > 0 ? quarter.interviews : "—"}
            </div>
            <div className="text-black text-xs font-normal leading-4">
              Interviews
            </div>
          </div>
        </div>
        <div className="w-full inline-flex justify-start items-center gap-2">
          <div className="w-[18px] h-[18px] relative overflow-hidden">
            <UserCheckValidateIcon />
          </div>
          <div className="w-[65.1px] inline-flex flex-col justify-start items-start">
            <div className="text-[#12811C] text-lg font-semibold">
              {quarter.hires > 0 ? quarter.hires : "—"}
            </div>
            <div className="text-black text-xs font-normal leading-4">
              Hires
            </div>
          </div>
        </div>
      </div>
      <div className="w-full h-[65px] pt-[9px] border-t border-[#E5E7EB] flex flex-col justify-start items-start gap-1">
        <div className="w-full h-4 inline-flex justify-start items-start">
          <div className="flex-1 text-[#535455] text-xs font-normal leading-4">
            Conversion Rates:
          </div>
        </div>
        <div className="w-full h-4 inline-flex justify-between items-start">
          <div className="w-[89.71px] h-4 flex justify-start items-start">
            <div className="text-[#535455] text-xs font-normal leading-4">
              Apps→Interview:
            </div>
          </div>
          <div className="text-[#BF4900] text-xs font-medium leading-4">
            {quarter.appToIntRate > 0 ? `${quarter.appToIntRate}%` : "—"}
          </div>
        </div>
        <div className="w-full h-4 inline-flex justify-between items-start">
          <div className="w-[83.53px] h-4 flex justify-start items-start">
            <div className="text-[#535455] text-xs font-normal leading-4">
              Interview→Hire:
            </div>
          </div>
          <div className="text-[#12811C] text-xs font-medium leading-4">
            {quarter.intToHireRate > 0 ? `${quarter.intToHireRate}%` : "—"}
          </div>
        </div>
      </div>
    </div>
  );
}
